module.exports = __webpack_public_path__ + "img/solutionicon7.610fcf63.png";